export default __webpack_public_path__ + "static/media/34.f2fba787.png";